import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Avatar,
  Card,
  Grid,
  CardContent,
  Typography,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  statsItem: {
    alignItems: 'center',
    display: 'flex'
  },
  statsIcon: {
    marginRight: theme.spacing(1)
  },
  avatar: {
    width: 'auto',
    height: 'auto'
  }
}));

const NotificationCardPreview = ({
  className, notification, onUpload, ...rest
}) => {
  const classes = useStyles();

  const translateApp = (app) => {
    switch (app) {
      case 'clients':
        return 'Pedidos';
      case 'partners':
        return 'Aliados';
      case 'drivers':
        return 'Repartidores';
      default: return '';
    }
  };

  const imageByApp = (app) => {
    switch (app) {
      case 'clients':
        return 'https://storage.googleapis.com/bucket-adomi-dev/apps_images/Icono_adomi_clientes.png';
      case 'partners':
        return 'https://storage.googleapis.com/bucket-adomi-dev/apps_images/Icono_adomi_aliados.png';
      case 'drivers':
        return 'https://storage.googleapis.com/bucket-adomi-dev/apps_images/Icono_adomi_drivers.png';
      default: return '';
    }
  };

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid container spacing={1}>
          <Grid container item xs={3} direction="column" justify="center" alignItems="center">
            <Avatar
              className={classes.avatar}
              alt="notification"
              src={imageByApp(notification?.app)}
              variant="square"
            />
          </Grid>
          <Grid item xs={9}>
            <Typography
              align="left"
              color="textPrimary"
              gutterBottom
              variant="h5"
            >
              {notification?.title}
            </Typography>
            <Typography
              align="left"
              color="textPrimary"
              gutterBottom
              variant="body2"
            >
              {notification?.body}
            </Typography>
            {
              notification?.topic?.length === 0
                ? (
                  <Typography
                    align="left"
                    color="textPrimary"
                    gutterBottom
                    variant="caption"
                  >
                    {
                      notification?.app?.length > 0
                        ? `App: ${translateApp(notification?.app)}`
                        : ''
                    }
                  </Typography>
                ) : (
                  <Typography
                    align="left"
                    color="textPrimary"
                    gutterBottom
                    variant="caption"
                  >
                    {
                      notification?.topic?.length > 0
                        ? `Topic: ${notification?.topic}`
                        : ''
                    }
                  </Typography>
                )
            }
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

NotificationCardPreview.propTypes = {
  className: PropTypes.string,
  notification: PropTypes.object,
  onUpload: PropTypes.func,
};

NotificationCardPreview.defaultProps = {
  className: '',
  notification: {},
  onUpload: () => {},
};

export default NotificationCardPreview;
